import {CsvMetadataRestDto} from "@/api/pharma-cpc-import/models";

export class CsvMetadataRestDtoModel implements CsvMetadataRestDto {
    delimiter: string;
    has_header: boolean;

    constructor(delimiter: string, has_header: boolean) {
        this.delimiter = delimiter;
        this.has_header = has_header;
    }

    static createWithDefaults(): CsvMetadataRestDtoModel {
        return new this(';', false);
    }
}
